import { DWT_PAYLOADS_TABLE_NAME } from '../../dwt-payloads/dwt-payloads.constants';
import {
    DWT_PAYLOADS_FIXED_SHEET_COLUMNS,
    DWT_PAYLOADS_FIXED_TABLE_HEADERS,
} from '../../dwt-payloads/models/dwt-payloads-sheet.model';
import { mapDwtPayloadApiRecordToRow } from '../../dwt-payloads/utils/map-dwt-payload-api-record-to-row.util';
import type { TabularSheetCellValue, TabularSheetPayload } from '../../shared/tabular-sheet-payload.model';

function uniquePayloadHeader(header: string, used: Set<string>): string {
    if (!used.has(header)) {
        used.add(header);
        return header;
    }
    const suffixed = `${header} (Payload)`;
    used.add(suffixed);
    return suffixed;
}

/**
 * Maps Get-RegulatoryReports records into a grid: metadata columns plus every payload field.
 */
export function formatDwtPayloadsRecordsToTabularSheet(records: unknown[]): TabularSheetPayload {
    const mapped = records.map(mapDwtPayloadApiRecordToRow);
    const usedHeaders = new Set<string>(DWT_PAYLOADS_FIXED_TABLE_HEADERS);
    const payloadHeaderOrder: string[] = [];
    const payloadHeaderByKey = new Map<string, string>();

    for (const row of mapped) {
        for (const key of Object.keys(row.payloadColumns)) {
            if (payloadHeaderByKey.has(key)) {
                continue;
            }
            const header = uniquePayloadHeader(key, usedHeaders);
            payloadHeaderByKey.set(key, header);
            payloadHeaderOrder.push(key);
        }
    }

    const columnHeaders = [
        ...DWT_PAYLOADS_FIXED_TABLE_HEADERS,
        ...payloadHeaderOrder.map((key) => payloadHeaderByKey.get(key) ?? key),
    ];

    const rows = mapped.map((row) => {
        const fixed: TabularSheetCellValue[] = DWT_PAYLOADS_FIXED_SHEET_COLUMNS.map(
            (col) => row[col.key]
        );
        const payloadCells = payloadHeaderOrder.map((key) => row.payloadColumns[key] ?? '');
        return [...fixed, ...payloadCells];
    });

    return {
        columnHeaders,
        rows,
        tableName: DWT_PAYLOADS_TABLE_NAME,
    };
}
